<template>
  <div class="sticky-top">
    <!-- topbar -->
    <div class="topbar">
      <div
        class="container-fluid d-flex align-items-center justify-content-between wrapper"
      >
        <!-- left  -->
        <div class="d-flex align-items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M13.8333 11.9784L12.1414 13.6567C11.8917 13.9128 11.5606 13.9996 11.2382 14C9.81252 13.9573 8.4649 13.257 7.35842 12.5378C5.5422 11.2165 3.87574 9.5782 2.82984 7.59832C2.4287 6.76809 1.95802 5.70878 2.00299 4.78209C2.007 4.43349 2.10094 4.09136 2.34645 3.86666L4.03831 2.17565C4.38963 1.87682 4.72938 1.98014 4.9542 2.32822L6.31531 4.90924C6.45857 5.21501 6.37639 5.54263 6.16265 5.76112L5.53933 6.38412C5.50085 6.43683 5.47635 6.49683 5.47573 6.56213C5.71475 7.48735 6.43886 8.34012 7.07854 8.92699C7.71821 9.51387 8.40579 10.309 9.29831 10.4972C9.40863 10.528 9.54376 10.5388 9.62269 10.4654L10.3478 9.72798C10.5978 9.53853 10.9587 9.44593 11.2255 9.60084H11.2382L13.6933 11.0503C14.0537 11.2762 14.0913 11.7128 13.8333 11.9784Z"
              fill="white"
            />
          </svg>
          <a href="tel:+8801897661850" class="ms-1 topbar__info text-white"
            >+880 1897 661850</a
          >

          <span class="mx-1 mx-lg-3">|</span>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
          >
            <path
              d="M14 3.35408V9.38462C14 9.94565 13.7695 10.4837 13.3593 10.8804C12.9491 11.2771 12.3927 11.5 11.8125 11.5H2.1875C1.60734 11.5 1.05094 11.2771 0.640704 10.8804C0.230468 10.4837 0 9.94565 0 9.38462V3.35408L6.77775 7.21085C6.84508 7.24925 6.92183 7.2695 7 7.2695C7.07817 7.2695 7.15492 7.24925 7.22225 7.21085L14 3.35408ZM11.8125 0.5C12.3508 0.499918 12.8701 0.691744 13.2713 1.03878C13.6725 1.38582 13.9272 1.8637 13.9869 2.381L7 6.35539L0.0131251 2.381C0.0727635 1.8637 0.327533 1.38582 0.728696 1.03878C1.12986 0.691744 1.64925 0.499918 2.1875 0.5H11.8125Z"
              fill="white"
            />
          </svg>

          <a
            href="mailto:hr@mediusware.com"
            class="ms-1 topbar__info text-white"
          >
            hr@mediusware.com</a
          >
        </div>

        <!-- right -->
        <div class="d-flex gap-lg-2 gap-1">
          <a href="https://www.facebook.com/mediusware/" target="_blank">
            <svg
              class="ms-1"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 8.04467C0 12.022 2.88867 15.3293 6.66667 16V10.222H4.66667V8H6.66667V6.222C6.66667 4.222 7.95533 3.11133 9.778 3.11133C10.3553 3.11133 10.978 3.2 11.5553 3.28867V5.33333H10.5333C9.55533 5.33333 9.33333 5.822 9.33333 6.44467V8H11.4667L11.1113 10.222H9.33333V16C13.1113 15.3293 16 12.0227 16 8.04467C16 3.62 12.4 0 8 0C3.6 0 0 3.62 0 8.04467Z"
                fill="white"
              />
            </svg>
          </a>

          <a href="https://twitter.com/mediuswareltd?lang=en" target="_blank">
            <svg
              class=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM11.8446 6.03036C11.85 6.11429 11.85 6.20179 11.85 6.2875C11.85 8.90893 9.85357 11.9286 6.20536 11.9286C5.08036 11.9286 4.0375 11.6018 3.15893 11.0393C3.31964 11.0571 3.47321 11.0643 3.6375 11.0643C4.56607 11.0643 5.41964 10.75 6.1 10.2179C5.22857 10.2 4.49643 9.62857 4.24643 8.84286C4.55179 8.8875 4.82679 8.8875 5.14107 8.80714C4.69237 8.71598 4.28906 8.47229 3.99967 8.11747C3.71028 7.76265 3.55265 7.31858 3.55357 6.86071V6.83571C3.81607 6.98393 4.125 7.075 4.44821 7.0875C4.1765 6.90642 3.95368 6.66109 3.79948 6.37327C3.64529 6.08544 3.56451 5.76402 3.56429 5.4375C3.56429 5.06786 3.66071 4.73036 3.83393 4.4375C4.33197 5.0506 4.95345 5.55204 5.65797 5.90922C6.3625 6.26641 7.1343 6.47135 7.92321 6.51071C7.64286 5.1625 8.65 4.07143 9.86071 4.07143C10.4321 4.07143 10.9464 4.31071 11.3089 4.69643C11.7571 4.6125 12.1857 4.44464 12.5679 4.21964C12.4196 4.67857 12.1089 5.06607 11.6964 5.31071C12.0964 5.26786 12.4821 5.15714 12.8393 5.00179C12.5696 5.39821 12.2321 5.75 11.8446 6.03036Z"
                fill="white"
              />
            </svg>
          </a>
          <div>
            <a
              target="_blank"
              href="https://www.instagram.com/mediusware_com/"
              class="social-icon"
            >
              <img
                src="../../../../public/assets/icon/instagram-brands-solid-full.svg"
                class=""
                alt="Instagram"
                style="background-color: white !important"
              />
            </a>
          </div>

          <a
            href="https://www.linkedin.com/company/mediusware-ltd"
            target="_blank"
          >
            <svg
              class=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 0C3.58167 0 0 3.58167 0 8C0 12.4183 3.58167 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58167 12.4183 0 8 0ZM6.04167 11.3158H4.42167V6.1025H6.04167V11.3158ZM5.22167 5.4625C4.71 5.4625 4.37917 5.1 4.37917 4.65167C4.37917 4.19417 4.72 3.8425 5.2425 3.8425C5.765 3.8425 6.085 4.19417 6.095 4.65167C6.095 5.1 5.765 5.4625 5.22167 5.4625ZM11.9583 11.3158H10.3383V8.42667C10.3383 7.75417 10.1033 7.2975 9.5175 7.2975C9.07 7.2975 8.80417 7.60667 8.68667 7.90417C8.64333 8.01 8.6325 8.16 8.6325 8.30917V11.315H7.01167V7.765C7.01167 7.11417 6.99083 6.57 6.96917 6.10167H8.37667L8.45083 6.82583H8.48333C8.69667 6.48583 9.21917 5.98417 10.0933 5.98417C11.1592 5.98417 11.9583 6.69833 11.9583 8.23333V11.3158Z"
                fill="white"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>

    <!-- nav -->
    <nav
      class="navbar navbar-expand-lg bg-body-tertiary bg-white navbar-size-new"
    >
      <div class="container-fluid wrapper">
        <!-- brand  -->
        <a class="navbar-brand" href="/">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="167"
            height="47"
            viewBox="0 0 167 47"
            fill="none"
          >
            <g clip-path="url(#clip0_1061_13125)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M100.93 16.4337C103.938 13.5892 106.932 10.7278 109.96 7.90427C111.839 6.15238 113.792 4.4829 116.077 3.25836C117.452 2.52036 118.893 2.05756 120.448 2.54956C121.744 2.9589 121.818 3.3554 120.828 4.30691C113.95 10.9251 106.986 17.4475 99.3073 23.1528C99.0576 23.3384 98.8369 23.5657 98.6034 23.7753C96.513 24.9521 94.6415 26.5352 92.258 27.1668C89.6101 27.8683 87.7671 26.3309 88.0342 23.5932C88.1766 22.1286 88.5946 20.7219 89.0065 19.3126C89.2115 18.6144 89.6438 17.9247 89.3976 16.8406C88.7924 17.5132 88.3486 18.0186 87.892 18.5126C85.7913 20.786 83.6553 23.0289 81.1973 24.9234C79.999 25.8459 78.7218 26.9292 77.0798 25.9923C75.4206 25.0455 75.6325 23.3573 75.6867 21.7803C75.707 21.5717 75.7403 21.3646 75.7863 21.1602C76.1909 18.6726 76.9464 16.2748 77.6795 13.8729C78.3008 11.8383 78.9085 9.80086 79.5222 7.76433C79.3769 7.66173 79.2295 7.55931 79.0839 7.45655C77.727 8.89641 76.384 10.3501 75.01 11.7734C73.5554 13.279 72.2178 14.9243 70.4464 16.0841C67.9537 17.7156 65.6978 16.5259 65.5413 13.5435C65.4403 11.613 66.1187 9.83388 66.6032 8.01596C66.8861 6.95406 67.3972 5.93905 67.4007 4.77387C64.259 7.01472 61.1369 9.12526 58.4978 11.8378C55.6859 14.4967 52.8841 17.1662 50.0575 19.8096C47.9928 21.7405 45.8886 23.6264 43.3749 24.9786C42.005 25.7167 40.5638 26.1703 39.0123 25.692C37.7245 25.2949 37.6421 24.8699 38.6193 23.9314C45.4491 17.3686 52.3532 10.8881 59.9686 5.21925C60.3016 4.97169 60.5943 4.6704 60.9058 4.39399C62.9394 3.34249 64.6956 1.78479 66.9572 1.1434C69.8791 0.315207 71.7489 1.86529 71.3976 4.85627C71.1946 6.58338 70.6379 8.2202 70.1593 9.87842C70.0436 10.2823 69.8178 10.6864 70.0662 11.2646C72.7633 8.49834 75.1995 5.67581 78.1499 3.39743C79.3862 2.44212 80.69 1.27823 82.3846 2.25668C84.0926 3.24354 83.8139 5.00739 83.7531 6.62905C83.7458 6.83518 83.6702 7.03898 83.6351 7.24521C83.2265 9.67722 82.4892 12.0212 81.7742 14.3733C81.1558 16.408 80.542 18.444 79.9326 20.4813C80.0685 20.574 80.204 20.6666 80.339 20.7592C81.8128 19.217 83.2771 17.6653 84.763 16.1342C86.0379 14.8197 87.2272 13.4068 88.7297 12.3363C89.7778 11.59 90.9624 10.9991 92.2391 11.6571C93.537 12.3265 93.8906 13.5943 93.9199 14.9787C93.9452 16.147 93.6466 17.2522 93.373 18.3736C92.9593 20.0661 92.2174 21.6777 92.005 23.5345C95.1473 21.2212 98.2923 19.1461 100.93 16.4337Z"
                fill="url(#paint0_linear_1061_13125)"
              />
              <path
                d="M3.94743 41.0581L10.818 44.0667C11.7142 44.4508 11.8211 44.9204 11.8211 45.4109C11.8211 46.0938 11.3302 46.5635 10.6474 46.5635C10.3485 46.5635 10.0075 46.5209 9.47401 46.2647L0.78925 42.2745C0.554262 42.1697 0.354669 41.9991 0.214604 41.7832C0.0745388 41.5674 0 41.3156 0 41.0583C0 40.801 0.0745388 40.5492 0.214604 40.3334C0.354669 40.1175 0.554262 39.9469 0.78925 39.8421L9.47401 35.8517C10.0075 35.5959 10.3485 35.5527 10.6474 35.5527C11.3302 35.5527 11.8211 36.0223 11.8211 36.7051C11.8211 37.1961 11.7142 37.6652 10.818 38.0494L3.94743 41.0581Z"
                fill="#00A88E"
              />
              <path
                d="M28.1027 40.5353C28.1027 39.1486 27.6332 38.6576 26.6518 38.6576C25.905 38.6576 25.1792 39.4259 25.1792 40.6635V44.7391C25.1792 46.2326 24.2616 46.9154 22.9815 46.9154C21.7011 46.9154 20.7834 46.2326 20.7834 44.7391V40.5353C20.7834 39.1486 20.3144 38.6576 19.3325 38.6576C18.5857 38.6576 17.8604 39.4259 17.8604 40.6635V44.7391C17.8604 46.2326 16.943 46.9154 15.6627 46.9154C14.3823 46.9154 13.4648 46.2326 13.4648 44.7391V37.292C13.4648 35.9265 14.1261 35.2012 15.5773 35.2012C16.879 35.2012 17.3909 35.9477 17.5402 37.2705H17.5833C18.3086 35.9477 19.5249 35.2012 21.2105 35.2012C22.6401 35.2012 24.1338 35.8408 24.5178 37.356C25.4568 35.7984 26.6731 35.2012 28.2307 35.2012C31.2606 35.2012 32.4983 37.0786 32.4983 39.5111V44.7391C32.4983 46.2326 31.5808 46.9154 30.3006 46.9154C29.0204 46.9154 28.1027 46.2326 28.1027 44.7391V40.5353Z"
                fill="#0061AF"
              />
              <path
                d="M40.7558 46.9154C37.2561 46.9154 34.5039 45.1015 34.5039 41.0476C34.5039 37.0147 37.2561 35.2012 40.7558 35.2012C45.6637 35.2012 47.1574 38.5721 47.1574 40.2366C47.1574 41.5596 46.5382 42.0292 45.1302 42.0292H38.8995C39.0059 43.4374 39.8172 44.3549 41.2466 44.3549C42.8471 44.3549 43.7857 42.9892 45.1302 42.9892C45.8986 42.9892 46.4959 43.7361 46.4959 44.4402C46.4959 45.6564 45.002 46.9154 40.7558 46.9154ZM43.0177 39.8525C43.0177 38.3163 42.0574 37.7614 40.9695 37.7614C39.9874 37.7614 38.9635 38.2951 38.8995 39.8525H43.0177Z"
                fill="#0061AF"
              />
              <path
                d="M56.7162 33.1958C56.7162 31.6806 57.4847 30.998 58.8503 30.998C60.2159 30.998 60.984 31.6806 60.984 33.1958V44.7822C60.984 46.1907 60.3437 46.916 59.0211 46.916C57.7617 46.916 57.1004 46.0413 57.1004 44.9106H57.0579C56.6954 46.3186 54.9666 46.916 53.7079 46.916C50.6348 46.916 48.7148 44.6328 48.7148 41.027C48.7148 38.8716 49.9096 35.2018 53.5799 35.2018C55.0306 35.2018 56.0334 35.8846 56.6738 36.9084H56.7162V33.1958ZM55.0948 38.6583C53.5799 38.6583 53.1104 39.8959 53.1104 41.1762C53.1104 42.3711 53.5154 43.7155 55.0095 43.7155C56.2683 43.7155 56.7802 42.6488 56.7802 41.0694C56.7802 39.5117 56.055 38.6583 55.0948 38.6583Z"
                fill="#0061AF"
              />
              <path
                d="M63.2266 37.3768C63.2266 35.8835 64.1443 35.2007 65.4244 35.2007C66.7047 35.2007 67.6222 35.8835 67.6222 37.3768V44.7386C67.6222 46.2321 66.7047 46.9149 65.4244 46.9149C64.1443 46.9149 63.2266 46.2321 63.2266 44.7386V37.3768ZM65.4244 30.25C65.8337 30.25 66.2339 30.3715 66.5742 30.5989C66.9146 30.8263 67.1799 31.1496 67.3365 31.5278C67.4931 31.906 67.5341 32.3221 67.4542 32.7236C67.3744 33.1251 67.1772 33.4938 66.8878 33.7833C66.5983 34.0727 66.2295 34.2699 65.8281 34.3497C65.4266 34.4296 65.0104 34.3886 64.6322 34.2319C64.2541 34.0753 63.9308 33.81 63.7034 33.4696C63.476 33.1293 63.3546 32.7291 63.3546 32.3197C63.3531 32.0475 63.4056 31.7777 63.5091 31.5259C63.6126 31.2741 63.765 31.0453 63.9575 30.8529C64.15 30.6604 64.3787 30.508 64.6305 30.4045C64.8823 30.301 65.1522 30.2485 65.4244 30.25Z"
                fill="#0061AF"
              />
              <path
                d="M77.5021 37.3773C77.5021 35.884 78.4198 35.2012 79.6999 35.2012C80.9802 35.2012 81.8977 35.884 81.8977 37.3773V44.8244C81.8977 46.19 81.2364 46.9154 79.7854 46.9154C78.4835 46.9154 77.9716 46.1686 77.8223 44.846H77.7794C77.0541 46.1686 75.8378 46.9154 74.1519 46.9154C71.1005 46.9154 69.8633 45.0378 69.8633 42.605V37.3773C69.8633 35.884 70.7807 35.2012 72.0611 35.2012C73.3414 35.2012 74.2589 35.884 74.2589 37.3773V41.5812C74.2589 42.7975 74.7924 43.4587 75.8803 43.4587C76.9686 43.4587 77.5021 42.605 77.5021 41.2826V37.3773Z"
                fill="#0061AF"
              />
              <path
                d="M89.0681 42.5837L87.7664 42.3064C84.5656 41.6236 83.6268 40.4712 83.6268 38.8283C83.6268 37.1211 84.8642 35.2012 89.2598 35.2012C91.8631 35.2012 94.5731 35.9265 94.5731 37.6334C94.5731 38.4018 93.9756 38.9991 93.122 38.9991C91.6714 38.9991 91.223 37.6334 89.1318 37.6334C88.3423 37.6334 87.8941 37.9109 87.8941 38.4229C87.8941 38.8499 88.0866 39.0632 89.2598 39.3189L91.1165 39.7244C93.5275 40.2579 95.021 41.261 95.021 43.0533C95.021 44.9953 93.57 46.9154 88.9612 46.9154C86.1234 46.9154 83.6055 46.0622 83.6055 44.2057C83.6055 43.4803 84.3096 42.8614 85.1629 42.8614C86.4008 42.8614 86.998 44.4829 89.1105 44.4829C90.0495 44.4829 90.4974 44.0346 90.4974 43.6081C90.4974 43.2241 90.2844 42.84 89.0681 42.5837Z"
                fill="#0061AF"
              />
              <path
                d="M96.1316 37.8034C95.9975 37.4339 95.9253 37.0448 95.918 36.6517C95.918 35.8403 96.6437 35.2007 97.4329 35.2007C98.5852 35.2007 98.7561 35.8194 98.9694 36.7156L100.612 43.5437H100.655L101.978 37.3344C102.234 36.1181 102.49 35.1574 103.941 35.2007C105.413 35.1574 105.712 36.0964 105.99 37.3344L107.334 43.5437H107.377L108.913 36.7156C109.105 35.8194 109.297 35.2007 110.449 35.2007C111.239 35.2007 111.964 35.8403 111.964 36.6517C111.957 37.0447 111.885 37.4338 111.751 37.8034L109.468 45.2295C109.02 46.7015 108.678 46.9149 107.441 46.9149C106.139 46.9149 105.819 46.5308 105.499 45.2934L103.962 39.1691H103.92L102.384 45.2934C102.063 46.5308 101.744 46.9149 100.442 46.9149C99.204 46.9149 98.863 46.7015 98.4145 45.2295L96.1316 37.8034Z"
                fill="#0061AF"
              />
              <path
                d="M123.829 43.6295C123.829 44.9314 124.149 45.23 124.149 45.7205C124.149 46.4249 123.488 46.9154 122.741 46.9154C121.397 46.9154 120.948 46.0622 120.906 45.1015C119.69 46.4463 118.281 46.9154 116.638 46.9154C114.867 46.9154 113.117 45.6991 113.117 43.7361C113.117 41.154 115.081 40.4289 117.47 40.1511L119.37 39.9377C120.116 39.8525 120.713 39.682 120.713 38.7854C120.713 37.8893 119.796 37.5053 118.751 37.5053C116.446 37.5053 116.382 39.2125 115.145 39.2125C114.355 39.2125 113.821 38.6576 113.821 38.0176C113.821 36.7798 115.571 35.2012 118.772 35.2012C121.76 35.2012 123.829 36.1611 123.829 38.4018V43.6295ZM120.713 41.3889C120.372 41.7091 119.732 41.8159 119.37 41.8797L118.239 42.0502C116.937 42.2425 116.233 42.6481 116.233 43.5867C116.233 44.291 116.894 44.8669 117.961 44.8669C119.668 44.8669 120.713 43.7574 120.713 42.605V41.3889Z"
                fill="#0061AF"
              />
              <path
                d="M126.688 36.6522C126.688 35.7132 127.307 35.2012 128.096 35.2012C128.886 35.2012 129.504 35.7132 129.504 36.6522V37.8468H129.547C129.91 36.5453 130.614 35.2012 132.129 35.2012C133.111 35.2012 133.836 35.8408 133.836 36.7161C133.836 37.8684 133.068 38.2734 132.3 38.2734H131.745C130.486 38.2734 129.803 39.1486 129.803 41.7305V45.358C129.803 46.19 129.462 46.9154 128.246 46.9154C127.029 46.9154 126.688 46.19 126.688 45.358V36.6522Z"
                fill="#0061AF"
              />
              <path
                d="M137.592 41.6452C137.592 43.2879 138.659 44.4829 140.473 44.4829C142.82 44.4829 142.82 42.9467 144.079 42.9467C144.825 42.9467 145.359 43.5867 145.359 44.1632C145.359 46.0407 142.35 46.9154 140.473 46.9154C136.119 46.9154 134.477 43.9708 134.477 41.261C134.477 37.6334 136.674 35.2012 140.366 35.2012C143.951 35.2012 145.999 37.74 145.999 40.3009C145.999 41.3674 145.679 41.6452 144.633 41.6452H137.592ZM143.055 39.8525C142.884 38.4229 141.817 37.3773 140.43 37.3773C138.872 37.3773 137.933 38.3376 137.592 39.8525H143.055Z"
                fill="#0061AF"
              />
              <path
                d="M152.21 31.7874C152.338 31.4457 152.552 30.9121 153.384 30.9121C153.874 30.9121 154.493 31.3179 154.493 32.0007C154.493 32.2353 154.408 32.4702 154.322 32.7047L149.223 46.1263C149.094 46.4677 148.881 47.0013 148.049 47.0013C147.558 47.0013 146.939 46.5958 146.939 45.913C146.939 45.6784 147.025 45.4435 147.11 45.209L152.21 31.7874Z"
                fill="#9A258F"
              />
              <path
                d="M163.028 41.0581L156.157 38.0494C155.261 37.6652 155.154 37.1961 155.154 36.7051C155.154 36.0223 155.645 35.5527 156.327 35.5527C156.626 35.5527 156.968 35.5959 157.501 35.8517L166.186 39.8421C166.421 39.9468 166.62 40.1174 166.76 40.3333C166.901 40.5491 166.975 40.801 166.975 41.0583C166.975 41.3157 166.901 41.5675 166.76 41.7833C166.62 41.9992 166.421 42.1698 166.186 42.2745L157.501 46.2647C156.968 46.5209 156.626 46.5635 156.327 46.5635C155.645 46.5635 155.154 46.0938 155.154 45.4109C155.154 44.9204 155.261 44.4508 156.157 44.0667L163.028 41.0581Z"
                fill="#00A88E"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_1061_13125"
                x1="37.957"
                y1="14.1289"
                x2="121.503"
                y2="14.1289"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#006EB9" />
                <stop offset="1" stop-color="#00A99D" />
              </linearGradient>
              <clipPath id="clip0_1061_13125">
                <rect
                  width="166.976"
                  height="46.08"
                  fill="white"
                  transform="translate(0 0.921875)"
                />
              </clipPath>
            </defs>
          </svg>
        </a>

        <!-- mobile button -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <g clip-path="url(#clip0_890_10079)">
              <path
                d="M22.5 21H1.50001C0.671548 21 0 20.3284 0 19.5C0 18.6716 0.671548 18 1.50001 18H22.5C23.3285 18 24.0001 18.6716 24.0001 19.5C24 20.3284 23.3285 21 22.5 21Z"
                fill="#002B4F"
              />
              <path
                d="M22.5 13.5H1.50001C0.671548 13.5 0 12.8284 0 12C0 11.1716 0.671548 10.5 1.50001 10.5H22.5C23.3285 10.5 24.0001 11.1715 24.0001 12C24.0001 12.8285 23.3285 13.5 22.5 13.5Z"
                fill="#002B4F"
              />
              <path
                d="M22.5 6.00002H1.50001C0.671548 6.00002 0 5.32847 0 4.50001C0 3.67155 0.671548 3 1.50001 3H22.5C23.3285 3 24.0001 3.67155 24.0001 4.50001C24.0001 5.32847 23.3285 6.00002 22.5 6.00002Z"
                fill="#002B4F"
              />
            </g>
            <defs>
              <clipPath id="clip0_890_10079">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>

        <!-- collapsable menu  -->
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <div class="me-auto"></div>
          <ul class="navbar-nav mb-2 mb-lg-0">
            <!-- <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Services

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M4.5 6.75L9 11.25L13.5 6.75"
                    stroke="#002B4F"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/web-development"
                    >Website Development</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/mobile-app-solution"
                    >Mobile App Development</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/e-commerce-solution"
                    >E-commerce Solution</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/enterprise-solution"
                    >Enterprise Solution</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/ui-ux-solution"
                    >UI/UX Design & Dev</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/api-integration"
                    >API Integration</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/software-development"
                    >Software Development</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/sqa"
                    >SQA Solution</a
                  >
                </li>

                <li>
                  <a
                    class="dropdown-item"
                    href="https://mediusware.com/service-details/digital-marketing-solution"
                    >Digital Marketing</a
                  >
                </li>
              </ul>
            </li> -->

            <!-- <li class="nav-item">
              <a class="nav-link" href="https://mediusware.com/project"
                >Projects</a
              >
            </li> -->
            <!-- 
            <li class="nav-item">
              <a class="nav-link" href="https://mediusware.com/about"
                >Why Mediusware</a
              >
            </li> -->

            <!-- <li class="nav-item">
              <a class="nav-link" href="https://mediusware.com/about"
                >Company</a
              >
            </li> -->

            <!-- <li class="nav-item">
              <a class="nav-link" href="/blog">Blog</a>
            </li> -->

            <!-- <li class="nav-item">
              <a
                class="nav-link cursor-pointer"
                @click="this.scrollToCareerOpenings"
                >Careers</a
              >
            </li> -->

            <!-- <li class="nav-item">
              <a class="nav-link" href="https://mediusware.com/team"
                >Our Team</a
              >
            </li> -->
            <li class="nav-item uppercase">
              <a class="nav-link" href="https://mediusware.com/">MAIN SITE</a>
            </li>
          </ul>

          <div class="d-flex" role="search">
            <button class="btn btn-primary d-flex book-a-call">
              <router-link
                v-if="!$store.state.activeUser"
                to="/login"
                class="text-white"
                aria-current="page"
                >Login
              </router-link>
              <router-link
                v-else
                to="/user"
                class="text-white"
                aria-current="page"
                >Dashboard
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<style scoped lang="scss">
.dropdown-menu {
  .dropdown-item {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    // active
    &:active {
      background-color: #0060af !important;
      color: white !important;
    }
  }
}

.nav-link {
  padding: 0.3rem 1rem !important;
  color: #002b4f !important;
  font-size: 16px;
  font-weight: 400;
}

.navbar-size-new {
  height: 5rem !important;
}

.navbar-toggler {
  border: none !important;
  padding: 10px 20px !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.book-a-call {
  margin-left: 1rem;
}

.social-icon {
  width: auto;
  height: 16px;
  overflow: hidden;
  border-radius: 50% !important;
  transition: all 0.5s;
  text-align: center;
}

.social-icon img {
  width: 16px;
  height: 16px;
  border-radius: 50% !important;
}

.topbar {
  background-color: #091e42;
  padding: 0.7rem 0;
  color: white;
  font-size: 11px;
  font-weight: 100;

  .topbar__info {
    font-size: 14px;
    font-weight: 400;

    @media screen and (max-width: 991px) {
      font-size: 11px;
    }
  }
}
</style>

<script>
export default {
  methods: {
    scrollToCareerOpenings() {
      document.querySelector(".careerHeader").scrollIntoView({
        behavior: "smooth",
      });
    },
  },
};
</script>
